import { render, staticRenderFns } from "./CreatePassThroughInvoice.yaml?vue&type=template&id=8c9dc212&component"
import script from "./CreatePassThroughInvoice.yaml?vue&type=script&lang=ts&component"
export * from "./CreatePassThroughInvoice.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports